import { gql } from "@apollo/client";

export const ERP_VERSION_DATA = gql`
  subscription erpVersionData {
    erpVersionData {
      clientId
      version
    }
  }
`;

export const CACHE_RESET = gql`
  subscription resetCache {
    resetCache
  }
`;

export const LANGUAGE_PUBLISHED = gql`
  subscription publishLanguage {
    publishLanguage
  }
`;

export const DEIMOS_VERSION = gql`
  subscription deimosVersionRetrieved {
    deimosVersionRetrieved {
      date
      version
    }
  }
`;
